export const EVENTS = {
  PAGE_VIEW: 'page_view',
  WHITEPAPER_DOWNLOAD: 'whitepaper_download',
  WHITEPAPER_OPEN: 'whitepaper_open',
  CONTACT_SUBMIT: 'contact_submit',
  RELEASE_SUBSCRIBE: 'release_subscribe',
  REVIEW_SUBMIT: 'review_submit',
  HOLDERS_COUNTRY_CLICK: 'holders_country_click',
  LANGUAGE_SWITCH: 'language_switch',
  SOCIAL_LINK_CLICK: 'social_link_click',
};
